import { createFileRoute } from "@tanstack/react-router";
import { ReportsOverview } from "../../components/reports/report-pages";

/** Central Report Engine › Overview: a card per module (SUKMA's layout). Staged at Sector 4 for a NOC (lib/noc-stages/access.ts). */
export const Route = createFileRoute("/_app/reports/")({
	component: ReportsIndexPage,
});

function ReportsIndexPage() {
	const { session } = Route.useRouteContext();
	return <ReportsOverview session={session} />;
}
